
export const siteMetadata = {
  siteUrl: 'https://lainasampo.fi',
  siteName: 'Lainasampo',
  defaultTitle: 'Lainasampo - Vertaile lainoja ja löydä paras lainatarjous',
  defaultDescription: 'Kilpailutamme lainasi puolestasi yli 20 eri pankissa ja rahoitusyhtiössä. Vertaile lainoja ja hae edullinen lainatarjous ilmaiseksi!',
  defaultKeywords: ['lainavertailu', 'kilpailuta laina', 'lainatarjous', 'halpa laina', 'hae lainaa', 'lainojen vertailu', 'edullinen laina', 'lainahakemus'],
  companyInfo: {
    name: 'Lainasampo Oy',
    email: 'asiakaspalvelu@lainasampo.fi',
    address: 'Mannerheimintie 20 B, 00100 Helsinki',
    phone: '+358 9 123 4567'
  },
  social: {
    twitter: 'https://twitter.com/lainasampo',
    facebook: 'https://facebook.com/lainasampo',
    instagram: 'https://instagram.com/lainasampo',
    linkedin: 'https://linkedin.com/company/lainasampo'
  }
};
